import styled from 'styled-components';

export const EmailChangeContainer = styled.div`
  margin-top: 74px;
`;
